import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import ReassignClientsBeforeDeactivationDialog from "./ReassignClientsBeforeDeactivationDialog";
import { useGlobalToast } from "components/GlobalToastProvider";

const DeactivateUserDialog = (props) => {
  const { isActive, numberOfClients, userPermissions, toggleClinicianActivation, basicInfo } =
    props;

  const id = basicInfo?.user_id || "";
  const clinicianId = basicInfo?.id || "";
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const { showToast } = useGlobalToast();

  const reactivationReq = !isActive && userPermissions.reactivate_clients;
  const deactivationReq = isActive && userPermissions.disable_client;

  const handleDialogOpen = (open) => {
    setDialogOpen(open);
  };

  useEffect(() => {
    setMessage(`The account was successfully ${isActive ? "deactivated" : "reactivated"}`);
  }, [isActive]);

  const handleToggleActivation = () => {
    if (isActive && numberOfClients > 0) {
      // Open the ReassignClientsBeforeDeactivationDialog if there are clients assigned
      handleDialogOpen(true);
    } else {
      toggleClinicianActivation({ id, reason: "", note: "", clinicianId });
      showToast({ message });
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color={isActive ? "error" : "secondary"}
        onClick={handleToggleActivation}
        fullWidth
        disabled={!reactivationReq && !deactivationReq}
      >
        {isActive ? "Deactivate Clinician" : "Reactivate Clinician"}
      </Button>
      <ReassignClientsBeforeDeactivationDialog
        open={dialogOpen}
        onClose={() => handleDialogOpen(false)}
      />
    </>
  );
};

export default DeactivateUserDialog;
